module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAYAAAD9lDaoAAAAAXNSR0IArs4c6QAAAK9JREFUKBWFkc0NwjAMhR1DyhK0Ei2CMShDcWACEIiREKlgCDjxMwU0TUydQ9Qi0r6TJX96frYBam0vabIv5hOu/wkPRRabt1ValyoEYokDCSCGBJSEQMH2m/MstR+tACgGIZ6Io3y9vD64x3IQF12ghxjcHadZBUYR0bjp2IJCIHKjTy2n0DjvxME1mdNvHp7inLo2c1ATECBeUkb5anG7N3NiZI2uj1iFAA/3PfgLKg90ZjrTt3MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./public/images/green-arrow.png
// module id = 1616
// module chunks = 1